import React from 'react';
import { IconProps } from '.';

type EyeIconProps = {
  color?: string;
} & IconProps;

export const EyeIcon: React.FC<EyeIconProps> = ({
  width = 20,
  height = 20,
  color = '#787878',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 20 12"
    >
      <path
        fill={color}
        d="M9.775 11.33C4.615 11.33.52 6.42.347 6.21L.184 6l.163-.2C.519 5.59 4.615.68 9.775.68c5.16 0 9.247 4.91 9.42 5.12l.172.2-.172.21c-.173.21-4.269 5.12-9.42 5.12zM.99 6c.844.93 4.49 4.69 8.786 4.69 4.298 0 7.943-3.76 8.777-4.69-.834-.93-4.489-4.69-8.777-4.69C5.488 1.31 1.833 5.07.99 6z"
      ></path>
      <path
        fill={color}
        d="M11.368 6c0 .328-.093.65-.268.922a1.608 1.608 0 01-.715.611 1.532 1.532 0 01-.92.095 1.573 1.573 0 01-.815-.454 1.683 1.683 0 01-.436-.85 1.726 1.726 0 01.09-.96c.121-.303.325-.562.587-.744a1.547 1.547 0 011.494-.154c.193.084.369.206.517.36.148.154.265.337.345.539.08.201.121.417.121.635z"
      ></path>
    </svg>
  );
};
